import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type CreateRuleModalContext = {
  onConfirm: (id: string) => void | Promise<void>;
};

let context: CreateRuleModalContext | null = null;

export function openCreateRuleModal(next: CreateRuleModalContext): void {
  context = next;
  ModalComponent.attach("createRuleModal", appScope.id);
}

export function getCreateRuleModalContext(): CreateRuleModalContext | null {
  return context;
}

export function clearCreateRuleModalContext(): void {
  context = null;
}
